module.exports = {
	guest_type: [
		{
			value: 'staff',
			label: 'Staff'
		},
		{
			value: 'vip',
			label: 'VIP'
		}
	]
};
